export default __webpack_public_path__ + "static/char-15-anr-ab5838a3984d8d31a52d7e7125e6e8a4.gif";